export const METHOD_ACCORDION_SKELETON_KEYS = [
  "skeleton-row-pix",
  "skeleton-row-debit",
  "skeleton-row-credit",
];
